export default {
    webPushEndpointId: 'travelata-webpush',
    endpointId: 'travelata',
    pointOfContactSystemName: 'travelata.ru',
    firebaseMessagingSenderId: '306980008454',
};